import { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../auth/AuthContext';
import { MemberProposal } from '../../auth/memberApi';
import './index.css';
import { Link } from 'react-router-dom';

const CustomerProposals = () => {
  const { downloadProposal, listProposals } = useAuth();
  const [proposals, setProposals] = useState<MemberProposal[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [busyId, setBusyId] = useState('');
  const [error, setError] = useState('');

  const loadProposals = useCallback(async () => {
    setIsLoading(true);
    setError('');
    try {
      setProposals(await listProposals());
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : 'Unable to load proposals.');
    } finally {
      setIsLoading(false);
    }
  }, [listProposals]);

  useEffect(() => { loadProposals(); }, [loadProposals]);

  const handleDownload = async (proposalId: string) => {
    setBusyId(proposalId);
    setError('');
    try {
      const download = await downloadProposal(proposalId);
      window.open(download.downloadUrl, '_blank', 'noopener,noreferrer');
    } catch (requestError) {
      setError(requestError instanceof Error ? requestError.message : 'Unable to download proposal.');
    } finally {
      setBusyId('');
    }
  };

  return (
    <section className="customer-proposals-page">
      <div className="customer-proposals-header">
        <p>Member proposals</p>
        <h1>Your Hogcloud proposals.</h1>
        <span>Secure project proposals and documents will appear here when available.</span>
      </div>

      {error && <p className="customer-proposals-error" role="alert">{error}</p>}
      {isLoading ? <div className="customer-proposals-empty"><h2>Loading proposals…</h2></div>
        : proposals.length === 0 ? <div className="customer-proposals-empty">
        <h2>No proposals yet.</h2>
        <p>
          When Hogcloud prepares a proposal for your account, it will be listed here
          with secure document access.  <br></br><br></br>A proposal is for a project relating to a service and provides an estimate and Statement Of Work.
          If you are interested in a service from Hogcloud, send us a message.
        </p>
        <Link to="/contact" className="about-button">
          Contact Us
        </Link>
      </div> : <ul className="customer-proposals-list">
        {proposals.map((proposal) => (
          <li key={proposal.proposalId}>
            <div><strong>{proposal.proposalName}</strong><span>{proposal.status || 'DRAFT'}</span></div>
            <button type="button" disabled={busyId === proposal.proposalId} onClick={() => handleDownload(proposal.proposalId)}>
              {busyId === proposal.proposalId ? 'Preparing…' : 'Download'}
            </button>
          </li>
        ))}
      </ul>}
    </section>
  );
};

export default CustomerProposals;
